import Paper from '@material-ui/core/Paper';
import { withStyles } from '@material-ui/core/styles';
import { emphasize } from '@material-ui/core/styles/colorManipulator';
import TextField from '@material-ui/core/TextField';
import Typography from '@material-ui/core/Typography';
import React from "react";
import Select from 'react-select';
import ActionsContext from '../ActionsContextV2';
import _ from 'lodash';
import { Divider } from '@material-ui/core';
// import ActionsProjectSearchListItem from './ActionsProjectSearchListItem'
import SearchIcon from "@material-ui/icons/Search";
import { connect } from 'react-redux';
import { fetchProjects } from '../../../reduxActions/ProjectActions';
import ActionProjectSearchListItem from './ActionsProjectSearchListItem';

const styles = theme => ({
  root: {
    flexGrow: 1,
    height: 250,
  },
  input: {
    display: 'flex',
    padding: 0,
    height: 40,
  },
  valueContainer: {
    display: 'flex',
    flexWrap: 'wrap',
    flex: 1,
    alignItems: 'center',
  },
  chip: {
    margin: '18px',
  },
  chipFocused: {
    backgroundColor: emphasize(
      theme.palette.type === 'light' ? theme.palette.grey[300] : theme.palette.grey[700],
      0.08,
    ),
  },
  noOptionsMessage: {
    padding: `${theme.spacing(1)}px ${theme.spacing(2)}px`,
  },
  singleValue: {
    fontSize: 16,
  },
  placeholder: {
    position: 'absolute',
    left: 2,
    fontSize: 16,
  },
  paper: {
    position: 'absolute',
    zIndex: 1,
    marginTop: theme.spacing(1),
    left: 0,
    right: 0,
  },
  divider: {
    height: theme.spacing(2),
  }
});

const ListStyles = {
  groupLabel: {
    fontWeight: 500,
    color: 'black',
    fontSize: 14,
    paddingBottom: 10
  },
  valueLabel: {
    fontSize: 15,
    whiteSpace: 'nowrap',
    overflow: 'hidden',
    textOverflow: 'ellipsis',
    width: '320px',
  }
};

const inputComponent = ({ inputRef, ...props }) => <div ref={inputRef} {...props} />;

const NoOptionsMessage = props => (
  <Typography
    color="textSecondary"
    className={props.selectProps.classes.noOptionsMessage}
    {...props.innerProps}
  >
    {props.children}
  </Typography>
);

const formatGroupLabel = data => (
  <div>
    <div style={ListStyles.groupLabel}>
      <span>{data.label}</span>
    </div>
    <Divider />
  </div>
);

const Placeholder = props => (
  <Typography
    color="textSecondary"
    className={props.selectProps.classes.placeholder}
    {...props.innerProps}
  >
    {props.children}
  </Typography>
);

const SingleValue = props => {
  const project = JSON.parse(props.children);

  if (!props.selectProps.inputValue && props.selectProps.menuIsOpen) {
    return null;
  }

  return (
    <div style={ListStyles.valueLabel}>
      {project.preferredName ? project.preferredName : project.name}
    </div>
  );
}

const ValueContainer = props => {
  return <div className={props.selectProps.classes.valueContainer}>{props.children}</div>;
}

const Menu = (props) => (
  <Paper square className={props.selectProps.classes.paper} {...props.innerProps}>
    {props.children}
  </Paper>
);

const Control = (props) => (
  <TextField
    fullWidth
    InputProps={{
      inputComponent,
      inputProps: {
        className: props.selectProps.classes.input,
        inputRef: props.innerRef,
        children: props.children,
        ...props.innerProps,
      },
    }}
    {...props.selectProps.textFieldProps}
  />
);

const DropdownIndicator = (props) => (
  <div style={{ paddingLeft: 10 }}>
    <SearchIcon />
  </div>
)

const projectHasActions = (project) => {
  if (!project || !project.functions || project.functions.length === 0) {
    return false;
  }

  return project.functions.some((projectFunction) => projectFunction && Number(projectFunction.actions) > 0);
}

const normalize = (value) => (value || '').toString().trim().toLowerCase();

const getVisibleProjects = ({ actionProjects = [], gbus = [], approvalRoles = [] }) => {
  const visibleProjectsById = _.keyBy(actionProjects.filter((project) => project && project.id), 'id');
  const gbuScopedRoles = approvalRoles.filter((role) => normalize(role && role.scope) === 'gbu');
  const projectRoleNames = new Set(
    approvalRoles.flatMap((role) => [normalize(role && role.project)]).filter(Boolean)
  );
  const gbuRoleNames = new Set(gbuScopedRoles.map((role) => normalize(role && role.gbu)).filter(Boolean));
  const hasGlobalGbuApproverRole = gbuScopedRoles.some((role) => !normalize(role && role.gbu));

  gbus.forEach((gbu) => {
    const gbuName = normalize(gbu && gbu.name);
    const canSeeGbuProjects = hasGlobalGbuApproverRole || gbuRoleNames.has(gbuName);

    (gbu && gbu.projects ? gbu.projects : []).forEach((project) => {
      if (!project || !project.id) {
        return;
      }

      const projectNames = [normalize(project.name), normalize(project.preferredName)].filter(Boolean);
      const canSeeProject = canSeeGbuProjects || projectNames.some((projectName) => projectRoleNames.has(projectName));

      if (!canSeeProject || visibleProjectsById[project.id]) {
        return;
      }

      visibleProjectsById[project.id] = project;
    });
  });

  return Object.values(visibleProjectsById);
}



class ProjectLookupSelect extends React.Component {

  static contextType = ActionsContext;

  constructor(props) {
    super(props);

    this.state = {
      filteredProjects: [],
      searchTerm: '',
      selectedProject: null,
      menuIsOpen: false,

    }
  }



  componentDidMount() {
    this.filterProjects();
  }

  filterProjects() {
    const projects = this.context.actionsRedux.projectFunctions;
    if (this.state.searchTerm) {
      this.setState({ filteredProjects: [...projects] });
    } else {
      const filteredProjects = projects.filter(project => project.name.includes(this.state.searchTerm));
      this.setState(filteredProjects);
    }
  }

  clearSearch() {
    const projects = this.context.actionsRedux.projectFunctions;
    this.setState({ filterProjects: [...projects], searchTerm: '' });
  }

  render() {
    const selectOption = (project) => {
      this.setState({ menuIsOpen: false });
      try {
        const allProjects = this.context.actionsRedux.projectFunctions || [];
        const selectedProject = allProjects.find((p) => p.id === project.id) || project;
        this.context.selectProject(selectedProject);
        this.setState({ selectedProject });
      } catch (e) {
        console.error('Error parsing project:', e);
      }
    };
    

    const components = {
      NoOptionsMessage,
      Control,
      Menu,
      // Option: ActionsProjectSearchListItem,
      Option: (props) => {
        return <ActionProjectSearchListItem {...props} selectOption={selectOption} />
      },
      Placeholder,
      SingleValue,
      ValueContainer,
      DropdownIndicator,
    };

    const customFilter = (option, inputValue) => {
      const label = option.data.label.toLowerCase();
    
      // If it's an option, check if its label matches the search term
      if (label.includes(inputValue.toLowerCase())) {
        return true;
      }
    
      // If the option is a group (has 'options' array), filter its sub-options
      if (option.data.options && option.data.options.length > 0) {
        // Filter sub-options based on search term
        const filteredSubOptions = option.data.options.filter(subOption =>{
          const jsonObject = JSON.parse(subOption.label);
          return jsonObject.name.toLowerCase().includes(inputValue.toLowerCase())
        }
        );
    
        // If any sub-option matches, include the group and its filtered options
        if (filteredSubOptions.length > 0) {
          // Update the group to include only the filtered sub-options
          option.data.options = filteredSubOptions;
          return true;  // Return true to include this group in the result
        }
      }
    
      return false;  // Return false to exclude if no match found
    };
    
      const approvalRoles = (this.context.aboutCurrentUser && this.context.aboutCurrentUser.approvalRoles) || [];
      const actionProjects = this.context.actionsRedux.projectFunctions || [];
      const projects = getVisibleProjects({ actionProjects, gbus, approvalRoles });

        let myProjects = projects.filter((project) => projectHasActions(project));
        let otherProjects = projects.filter((project) => !projectHasActions(project));

        const jsonfyProject = (project) => ({
          label: JSON.stringify(project),
          value: project.id
        });

        myProjects = myProjects.map(jsonfyProject);
        otherProjects = otherProjects.map(jsonfyProject);

        const myProjectsById = _.keyBy(myProjects, 'value');
        const otherProjectsById = _.keyBy(otherProjects, 'value');
        const gbus = (this.props.projects && this.props.projects.gbus) ? this.props.projects.gbus : [];

        const myProjectsTemp = gbus.map((item) => {
          const options = (item.projects || []).reduce((acc, project) => {
            const matchedProject = project ? myProjectsById[project.id] : null;
            if (matchedProject) {
              acc.push(matchedProject);
            }
            return acc;
          }, []);

          if (options.length > 0) {
            options.sort((a, b) => {
              const aProject = JSON.parse(a.label);
              const bProject = JSON.parse(b.label);
              const aName = (aProject.preferredName || aProject.name || '').toUpperCase();
              const bName = (bProject.preferredName || bProject.name || '').toUpperCase();
              return aName.localeCompare(bName);
            });
            return { label: item.name, options };
          }

          return null;
        }).filter(item => item !== null);

        const otherProjectsTemp = gbus.map((item) => {
          const options = (item.projects || []).reduce((acc, project) => {
            const matchedProject = project ? otherProjectsById[project.id] : null;
            if (matchedProject) {
              acc.push(matchedProject);
            }
            return acc;
          }, []);

          if (options.length > 0) {
            options.sort((a, b) => {
              const aProject = JSON.parse(a.label);
              const bProject = JSON.parse(b.label);
              const aName = (aProject.preferredName || aProject.name || '').toUpperCase();
              const bName = (bProject.preferredName || bProject.name || '').toUpperCase();
              return aName.localeCompare(bName);
            });
            return { label: item.name, options };
          }

          return null;
        }).filter(item => item !== null);

    const projectGroupsNew = [];

    if (myProjectsTemp?.length > 0) {
      projectGroupsNew.push({
        label: "My Actions",
        options: myProjectsTemp
      });
    } else if (myProjects.length > 0) {
      projectGroupsNew.push({
        label: "My Actions",
        options: [{ label: 'Loading Groups ...', options: myProjects }]
      });
    }

    if (otherProjectsTemp?.length > 0) {
      projectGroupsNew.push({
        label: "Other Projects (No Actions)",
        options: otherProjectsTemp
      });
    } else if (otherProjects.length > 0) {
      projectGroupsNew.push({
        label: "Other Projects (No Actions)",
        options: [{ label: 'Loading Groups ...', options: otherProjects }]
      });
    }

    const selectedValue = this.context.actionsRedux.selectedProject ? jsonfyProject(this.context.actionsRedux.selectedProject) : undefined;

    const { classes, theme } = this.props;
    const selectStyles = {
      menuList: base => ({
        ...base,
        maxHeight: window.innerHeight - 300
      }),
      input: base => ({
        ...base,
        color: theme.palette.text.primary,
        '& input': {
          font: 'inherit',
        },
      }),
    };

    return (
      <div>
        <Select
          value={selectedValue}
          inputValue={this.state.searchTerm}
          classes={classes}
          styles={selectStyles}
          options={projectGroupsNew} // Using nested structure with categories and subcategories
          formatGroupLabel={formatGroupLabel}
          components={components}
          placeholder="Search Projects"
          onInputChange={(searchTerm) => {
            if (!searchTerm) {
              this.clearSearch();
            } else {
              this.setState({ searchTerm })
              this.filterProjects()
            }
          }}
          filterOption={customFilter} // Use the custom filter here
          menuIsOpen={this.state.menuIsOpen} // Manage the open state of the dropdown
          onMenuClose={() => this.setState({ menuIsOpen: false })} // Close on menu close
          onMenuOpen={() => this.setState({ menuIsOpen: true })} // Open on menu open
        />
      </div>
    );
  }
}

const mapStateToProps = state => {
  const { projects } = state;
  return { reduxStore: projects, projects };
};

ProjectLookupSelect = withStyles(styles, { withTheme: true })(ProjectLookupSelect);
export default connect(mapStateToProps, { fetchProjects })(ProjectLookupSelect);
